import React from 'react'
import { connect } from 'react-redux'

import ReactModal from 'react-modal'
import { translate } from 'react-i18next'

import styled from 'styled-components'
import { ReactComponent as IconCloseFilter } from 'assets/img/icon/ic_close_filter.svg'
import PerfectScrollbar from 'react-perfect-scrollbar'

//#region
const customStyles = {
  content: {
    top: '80px',
    left: '50%',
    width: '850px',
    transform: 'translate(-50%)',
    bottom: 'auto',
    backgroundColor: 'var(--bg-th-even)',
    border: 'none',
  },
}

const StyleContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 24px;
  background: ${(props) => (props.theme === 'dark' ? '#1c192c' : '#ffffff')};
  border-radius: 8px;
`

const StyleHeader = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  color: var(--half_white);
  font-weight: 500;
  font-size: 16px;
`

const StyleBody = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
`

const StyleContent = styled.div`
  display: flex;
  flex-direction: column;

  label {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: ${(props) => (props.theme === 'dark' ? '#ececec' : '#000000')};
  }
`

const StyledDivTable = styled.div`
  position: relative;

  table {
    position: relative;
  }
  table thead th {
    position: sticky;
    top: 0;
    background: #312e41;
    border: 0;
  }
  table tbody td {
    border-color: #2e2d3d;
  }

  table.theme-light thead th {
    background: #666666;
  }
  table.theme-light.table-analysis tbody tr:nth-child(odd) td {
    background: #eeeeee;
  }
`
//#endregion

function BackTestModal(props) {
  const [dataShow, setDataShow] = React.useState([])
  const { onClose, t, data, theme } = props

  React.useEffect(() => {
    try {
      console.log(data.SEC_BT_PERF)
      // let _arrData = [];

      if (data.SEC_BT_PERF) {
        // const _res = data.SEC_BT_PERF.slice(1, -1);
        // const _resArr = _res.split('}');
        // for (let index = 0; index < _resArr.length; index++) {
        //   let _obj = {};
        //   let _data = _resArr[index];
        //   if (_data) {
        //     _data = _resArr[index].slice(index === 0 ? 1 : 2);

        //     _data.split(',').forEach((element) => {
        //       const _elChild = element.split(':');
        //       if (element && !!_elChild.length) _obj[_elChild[0]] = _elChild[1];
        //     });
        //     _arrData.push(_obj);
        //   }
        // }
        // console.log(_arrData);
        setDataShow(data.SEC_BT_PERF)
      }
    } catch (error) {
      console.log(error)
    }
  }, [])

  return (
    <ReactModal
      isOpen={true}
      contentLabel="onRequestClose Example"
      onRequestClose={onClose}
      //   shouldCloseOnOverlayClick={true}
      style={customStyles}
    >
      <StyleContainer theme={theme}>
        <StyleHeader>
          {t('algo.signal.' + data.REALTIME_FORMULA_ID)}
          <a className="ml-auto" onClick={onClose}>
            <IconCloseFilter />
          </a>
        </StyleHeader>
        <StyleBody>
          <StyleContent theme={theme}>
            <label theme={theme}>
              {t('algo.cb.txt-Backtest-resul', { symbol: data.SECURITY_CODE })}
            </label>
            <PerfectScrollbar
              style={{ maxHeight: 'calc(100vh - 265px)' }}
              className="w-100"
            >
              <StyledDivTable>
                <table className={'table table-analysis theme-' + theme}>
                  <thead>
                    <tr>
                      <th className="text-nowrap text-left pl-4">
                        {t('algo.cb.txt-year')}
                      </th>
                      <th className="text-nowrap text-right">
                        {t('algo.cb.txt-buy-signal')}
                      </th>
                      <th className="text-nowrap text-right">
                        {t('algo.cb.txt-sell-signal')}
                      </th>
                      <th className="text-nowrap text-right">
                        {t('algo.cb.txt-buy-order')}
                      </th>
                      <th className="text-nowrap text-right">
                        {t('algo.cb.txt-sell-order')}
                      </th>
                      <th className="text-nowrap text-right">
                        {t('algo.cb.txt-buy-gain')}
                      </th>
                      <th className="text-nowrap text-right">
                        {t('algo.cb.txt-buy-lost')}
                      </th>
                      <th className="text-nowrap text-right pr-4">
                        Return (%)
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataShow &&
                      dataShow.map((item, index) => (
                        <tr key={index}>
                          <td className="text-left text-uppercase pl-4">
                            {item.y == '9999' ? t('txt-ave') : item.y}
                          </td>
                          <td className="text-right">{item.bs}</td>
                          <td className="text-right">{item.ss}</td>
                          <td className="text-right">{item.bo}</td>
                          <td className="text-right">{item.so}</td>
                          <td className="text-right">{item.bg}</td>
                          <td className="text-right">{item.bl}</td>
                          <td
                            className={
                              'text-right pr-4 ' +
                              (item.r > 0
                                ? 'color-up'
                                : item.r < 0
                                ? 'color-down'
                                : '')
                            }
                          >
                            {item.r}
                          </td>
                          {/* <td className="text-right">{item.ir}</td> */}
                        </tr>
                      ))}
                  </tbody>
                </table>
              </StyledDivTable>
            </PerfectScrollbar>
          </StyleContent>
        </StyleBody>
      </StyleContainer>
    </ReactModal>
  )
}

export default connect()(translate('translations')(BackTestModal))
